import axios from "axios"

const DivisaService = {
  getDivisas() {
    return axios.get(`/Divisa`)
  },
}

export default DivisaService
